import refs from '../refs/refs';

window.addEventListener('DOMContentLoaded', () => {
  const date = new Date();
  if (refs.currentYear) {
    refs.currentYear.textContent = date.getFullYear();
  }
});
